import OutlineButton from "./OutlineButton";

interface CloseModalButtonPros {
  showBorder?: boolean;
  close?: () => any;
  closeModalLabel: string;
  mt?: string;
  bg?: string;
}

export function CloseModalButton({
  showBorder = true,
  close,
  closeModalLabel,
  mt,
  bg,
}: CloseModalButtonPros) {
  return (
    <OutlineButton
      bgColor={bg}
      borderWidth={showBorder ? 1 : 0}
      mt={mt}
      onClick={close}
    >
      {closeModalLabel}
    </OutlineButton>
  );
}
